"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Notification = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const date_fns_1 = require("date-fns");
const Card_1 = __importDefault(require("@material-ui/core/Card/Card"));
const CardContent_1 = __importDefault(require("@material-ui/core/CardContent/CardContent"));
const CardHeader_1 = __importDefault(require("@material-ui/core/CardHeader/CardHeader"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Menu_1 = __importDefault(require("@material-ui/core/Menu"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const MoreVert_1 = __importDefault(require("@material-ui/icons/MoreVert"));
const NewReleases_1 = __importDefault(require("@material-ui/icons/NewReleases"));
const notification_context_1 = require("../../modules/notification/notification-context");
const action_button_1 = require("../../composite/action-button/action-button");
const locale_context_1 = require("../../providers/locale/locale-context");
const delete_hook_1 = require("./actions/delete-hook");
const read_hook_1 = require("./actions/read-hook");
const unread_hook_1 = require("./actions/unread-hook");
const unsubscribe_hook_1 = require("./actions/unsubscribe-hook");
const notification_styles_1 = require("./notification-styles");
function Notification({ item, refreshNotifications, }) {
    const classes = (0, notification_styles_1.useNotificationStyles)();
    const intl = (0, react_intl_1.useIntl)();
    const { locale } = (0, react_1.useContext)(locale_context_1.LocaleContext);
    const { notificationUrl, allowUnsubscribe = true } = (0, react_1.useContext)(notification_context_1.NotificationContext);
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const { handleRead } = (0, read_hook_1.useRead)({ refresh: refreshNotifications });
    const { handleUnread } = (0, unread_hook_1.useUnread)({ refresh: refreshNotifications });
    const date = (0, date_fns_1.formatDistanceToNow)((0, date_fns_1.parseISO)(item.created), {
        locale: locale.dateFnsLocale,
        addSuffix: true,
    });
    return (react_1.default.createElement(Card_1.default, { className: classes.notification },
        react_1.default.createElement(Menu_1.default, { anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose },
            !(item === null || item === void 0 ? void 0 : item.read) && (react_1.default.createElement(MenuItem_1.default, { onClick: () => handleRead(item.id) },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__NOTIFICATION__ACTIONMENU__MARK_AS_READ", defaultMessage: "Ozna\u010Dit jako p\u0159e\u010Dten\u00E9" }))),
            (item === null || item === void 0 ? void 0 : item.read) && (react_1.default.createElement(MenuItem_1.default, { onClick: () => handleUnread(item.id) },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ES__NOTIFICATION__ACTIONMENU__MARK_AS_UNREAD", defaultMessage: "Ozna\u010Dit jako nep\u0159e\u010Dten\u00E9" }))),
            react_1.default.createElement(action_button_1.ActionButton, { promptKey: "DELETE_NOTIFICATION", apiCall: () => (0, delete_hook_1.deleteNotificationApiCall)(notificationUrl, item.id), ButtonComponent: (props) => (react_1.default.createElement(MenuItem_1.default, { ...props }, props.label)), buttonLabel: intl.formatMessage({
                    id: 'ES__NOTIFICATION__ACTIONMENU__DELETE',
                    defaultMessage: 'Smazat notifikaci',
                }), dialogText: intl.formatMessage({
                    id: 'ES__NOTIFICATION__ACTIONMENU__DELETE__TEXT',
                    defaultMessage: 'Skutečně chcete smazat notifikaci?',
                }), dialogTitle: intl.formatMessage({
                    id: 'ES__NOTIFICATION__ACTIONMENU__DELETE__TITLE',
                    defaultMessage: 'Varování',
                }), onSuccess: async () => refreshNotifications() }),
            allowUnsubscribe && (react_1.default.createElement(action_button_1.ActionButton, { promptKey: "UNSUBSCRIBE_NOTIFICATION", apiCall: () => (0, unsubscribe_hook_1.unsubscribeNotificationApiCall)(notificationUrl, item.event), ButtonComponent: (props) => (react_1.default.createElement(MenuItem_1.default, { ...props }, props.label)), buttonLabel: intl.formatMessage({
                    id: 'ES__NOTIFICATION__ACTIONMENU__UNSUBSCRIBE',
                    defaultMessage: 'Nechci dostávat podobné notifikace',
                }), dialogText: intl.formatMessage({
                    id: 'ES__NOTIFICATION__ACTIONMENU__UNSUBSCRIBE__TEXT',
                    defaultMessage: 'Skutečně nechcete být upozorňováni o podobných událostech?',
                }), dialogTitle: intl.formatMessage({
                    id: 'ES__NOTIFICATION__ACTIONMENU__UNSUBSCRIBE__TITLE',
                    defaultMessage: 'Varování',
                }), onSuccess: async () => refreshNotifications() }))),
        react_1.default.createElement(CardHeader_1.default, { avatar: !item.read ? react_1.default.createElement(NewReleases_1.default, { color: "secondary" }) : null, action: react_1.default.createElement(IconButton_1.default, { size: "small", onClick: handleClick },
                react_1.default.createElement(MoreVert_1.default, null)), title: react_1.default.createElement("div", { className: classes.notificationTitle, dangerouslySetInnerHTML: { __html: item.subject } }), subheader: date, classes: {
                action: classes.notificationActionButton,
                subheader: classes.notificationSubheader,
            } }),
        react_1.default.createElement(CardContent_1.default, null,
            react_1.default.createElement(Typography_1.default, { variant: "body1", color: "textSecondary", component: "div", className: classes.notificationContent },
                react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: item.content } })))));
}
exports.Notification = Notification;
//# sourceMappingURL=notification.js.map